import { Language, Locale } from "~/utils/constants";

export const languageToLocale = {
  [Language.EN]: Locale.EN,
  [Language.FR]: Locale.FR,
};

export const localeToLanguage = {
  [Locale.EN]: Language.EN,
  [Locale.FR]: Language.FR,
};
